export const defaultImageTypeQrcodeFormValues = {
  title: "",
  description: "",
  size: 1,
  target_url: "",
  regions: [],
};
